import { PhoneCall } from "lucide-react";

export function TestCallPanel({
  testPhone,
  testName,
  testCompany,
  testStatus,
  isPending,
  onPhoneChange,
  onNameChange,
  onCompanyChange,
  onSubmit,
}: {
  testPhone: string;
  testName: string;
  testCompany: string;
  testStatus: "idle" | "sending" | "sent" | "error";
  isPending: boolean;
  onPhoneChange: (value: string) => void;
  onNameChange: (value: string) => void;
  onCompanyChange: (value: string) => void;
  onSubmit: () => void;
}) {
  return (
    <div className="bg-white rounded-lg border p-4 space-y-4">
      <h2 className="font-semibold text-slate-900">テスト架電</h2>
      <p className="text-xs text-slate-500">
        任意の電話番号にテスト発信します。スクリプトの動作確認用です。
      </p>
      <div className="grid grid-cols-3 gap-3">
        <div>
          <label className="block text-xs font-medium text-slate-600 mb-1">電話番号 *</label>
          <input
            type="tel"
            value={testPhone}
            onChange={(e) => onPhoneChange(e.target.value)}
            className="w-full border rounded-lg px-3 py-2 text-sm"
            placeholder="09012345678"
          />
        </div>
        <div>
          <label className="block text-xs font-medium text-slate-600 mb-1">名前（任意）</label>
          <input
            type="text"
            value={testName}
            onChange={(e) => onNameChange(e.target.value)}
            className="w-full border rounded-lg px-3 py-2 text-sm"
            placeholder="田中太郎"
          />
        </div>
        <div>
          <label className="block text-xs font-medium text-slate-600 mb-1">会社名（任意）</label>
          <input
            type="text"
            value={testCompany}
            onChange={(e) => onCompanyChange(e.target.value)}
            className="w-full border rounded-lg px-3 py-2 text-sm"
            placeholder="テスト株式会社"
          />
        </div>
      </div>
      <div className="flex items-center gap-3">
        <button
          onClick={onSubmit}
          disabled={!testPhone || isPending}
          className="flex items-center gap-2 px-4 py-2 bg-orange-500 text-white rounded-lg hover:bg-orange-600 disabled:opacity-50 transition-colors text-sm"
        >
          <PhoneCall size={16} />
          {isPending ? "発信中..." : "テスト発信"}
        </button>
        {testStatus === "sent" && (
          <span className="text-sm text-green-600">発信キューに登録しました。数秒後に着信します。</span>
        )}
        {testStatus === "error" && (
          <span className="text-sm text-red-600">発信に失敗しました</span>
        )}
      </div>
    </div>
  );
}
